import React, { Component } from 'react';
import LoginPage from '../components/login/LoginPage';
import '../css/style.css';
import '../components/Home.css';
import {  Row, Col } from 'react-bootstrap';
import SimpleLayout from './SimpleLayout';


class LoginLayout extends Component {

  constructor(props) {
    super(props);
    this.state = { user: 'x' };
  }
  updateModel(name, value) {
    console.log("update user:" + value);
    //this.state.user= value;
    let oldState = this.state;
    this.setState({
      ...oldState,
      user: value
    });
  }
 
  render() {
    const { params } = this.props.match
    console.log("****loginLayout this.props.key :"+params.id);
    console.log("****loginLayout this.props :"+JSON.stringify(params));
    return (
      <SimpleLayout>
        <Row   className=" justify-content-lg-center ">
          <Col lg={6}>
              <LoginPage updateModel={this.updateModel.bind(this)} forward={params.id} idx={params.idx}/>
          </Col>
        </Row>
        
      </SimpleLayout>

    );
  }

}

export default LoginLayout;